export default {
  common: {
    clearAll: '全部清除',
    required: '必需',
    restart: '重启'
  },
  createUser: {
    acceptTermsAndConditions: '接受条款和条件',
    alreadyHaveAccount: '已经有账户了吗？%{pre}下载%{post}',
    checkEmail: '同时，将 Metrica Play 下载到你的电脑上',
    clubCompany: '组织/俱乐部',
    createdSuccessfully: '注册成功！检查您的注册电子邮件以获取验证链接。（检查垃圾邮件文件夹）',
    email: '电子邮件',
    invalidEmail: '无效的电子邮件',
    job: '工作/角色',
    lastName: '姓氏',
    name: '名字',
    noCustomOption: '选项不可用',
    noMatches: '没有匹配项，请自己写选项',
    password: '密码',
    passwordsDontMatch: '密码不匹配',
    passwordInvalid: '密码不符合要求',
    passwordRequirements: {
      minLength: '至少 %{count} 个字符',
      uppercase: '一个大写字母',
      lowercase: '一个小写字母',
      number: '一个数字（0-9）',
      maxLength: '最多 %{count} 个字符'
    },
    phone: '电话',
    phoneCode: '国家',
    proceed: '继续',
    repeatPassword: '再次输入密码',
    searchPhoneCode: '搜索…',
    seeTermsAndConditions: '查看条款和条件',
    signAgreement:
      '注册Metrica Sports账户意味着您同意%{pre1}隐私政策%{post1}和%{pre2}服务条款%{post2}',
    signUpHere: '创建您的帐户以开始使用。',
    sport: '运动',
    submitting: '正在启动...',
    title: '开始使用 %{product}',
    userKeyField: '有促销代码或用户密钥？填写此字段'
  },
  error: {
    downloadPlay: '如果您已经有账户，请下载最新版本的Play并登录。',
    emailTaken: '这封电子邮件已被接收',
    fieldTooLong: '部分字段过长，请缩短后重试',
    oops: '哎呀！',
    restart: '看来你正在尝试进入我们仍在开发的东西...',
    tryAgain: '请重试，如果此错误仍然存在，请联系 Metrica Sports 支持团队',
    userKey: '密钥无效。请检查您的密钥并重试或删除该字段以完成注册'
  },
  invitation: {
    acceptButton: '我接受我的账户变更',
    accepting: '接受...',
    cancelButton: '拒绝',
    description1:
      '当您被添加到新的Metrica Sports账户时，您现有的Metrica Sports账户（及其中包含的信息）的所有权将被转移并分配给新的Metrica Sports账户所有者。您的Metrica Sports账户当前包含的所有信息和数据，以及在您接受账户变更后保存的任何信息或数据，都将对新的Metrica Sports账户所有者和该账户上的任何管理员可见并可用，供其根据账户所有者的判断使用和与他人分享。',
    description2: '点击“I Accept My Account Change”即表示您同意并授权以下内容：',
    list1: '您现有的账户信息将被转移到新的Metrica Sports账户中。',
    list2:
      '从您当前账户转移到您的新Metrica Sports账户的所有账户信息，可以由新账户所有者和/或管理员管理。',
    list3:
      '在新的Metrica Sports账户中，你的角色将是“成员”。你将不再拥有当前账户的所有者或管理员权限。',
    list4:
      '你将继承你的新Metrica Sports账户的现有设置，这些设置可能会根据你在账户中的角色而变得更加宽松或限制性，而且你的设置可以由新的Metrica Sports账户所有者或管理员来管理。',
    list5: '如果您当前的设置与您即将加入的新账户的设置发生冲突，可能会被更改。',
    list6: '您的新账户可能无法提供您当前账户中的所有功能的访问权限。',
    list7: '一旦您启动账户转移，就无法撤销，而且您的所有账户信息将保留在单一账户中。',
    list8:
      '点击“I Accept My Account Change”后，您将成为%{pre1}%{email}%{post1}账户的受管理成员，并同意Metrica Sports的%{pre2}服务条款%{post2}和%{pre3}隐私声明%{post3}。',
    subtitle: '接受这个新的Metrica Sports账户邀请后，您将被添加到另一个Metrica Sports账户中。',
    title: '邀请'
  },
  jobs: {
    academyDirector: '青训总监',
    assistantCoach: '助理教练',
    dataAnalyst: '数据分析师',
    doctor: '队医',
    formerPlayer: '退役运动员',
    goalkeeperCoach: '守门员教练',
    headCoach: '主教练',
    journalist: '新闻工作者',
    other: '其他',
    performance: '体能与运动表现',
    player: '运动员',
    scout: '球探',
    sportsDirector: '体育总监',
    student: '学生',
    videoAnalyst: '视频分析师'
  },
  sports: {
    americanFootball: '美式足球',
    baseball: '棒球',
    basketball: '篮球',
    fieldHockey: '曲棍球',
    football: '足球/足球',
    futsal: '五人制足球',
    gaelicFootball: '盖尔足球',
    handball: '手球',
    iceHockey: '冰上曲棍球',
    lacrosse: '曲棍球',
    netball: '无挡板篮球',
    other: '其他',
    padel: '笼式网球',
    rugby: '橄榄球',
    tennis: '网球',
    volleyball: '排球'
  }
}
